import { SegmentedControl } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const ControlButton = styled(SegmentedControl.Button)`
  font-weight: 500;
  text-transform: capitalize;
`;
